import { render, staticRenderFns } from "./zncgBanKuai.vue?vue&type=template&id=4244de1c&scoped=true"
import script from "./zncgBanKuai.vue?vue&type=script&lang=js"
export * from "./zncgBanKuai.vue?vue&type=script&lang=js"
import style0 from "./zncgBanKuai.vue?vue&type=style&index=0&id=4244de1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4244de1c",
  null
  
)

export default component.exports